import {Store} from '@tanstack/react-store'
import type {V2FormResponse} from '@yandex-delivery/types/schemas/services/delivery-corp-account-api/docs/yaml/definitions/delivery_form'

import {appConfig} from 'src/shared/config'
import type {BduiParams, InitialRequest} from 'src/shared/types'

type StoreState = {
  ttl?: number
  descriptors?: V2FormResponse['descriptors']
  formRequest: InitialRequest
  offerId?: string
  settings?: BduiParams
}

export const store = new Store<StoreState>({
  descriptors: [],
  // у объекта из конфига нужно сохранить произвольный тип для возможности экстренных изменений в стейт,
  // поэтому кастую в нужный тип
  formRequest: appConfig.initialProps.bduiInitialRequest as InitialRequest,
  settings: undefined,
})
